export const formatHeat = (heat: number): string => {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)}万`;
  }
  return `${heat}`;
};